import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/rsm/";

export default class RSMApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getRSMs(params) {
    return await request.post(`${rootRoute}getRSMs`, {
      filter: params,
      parameters: {},
    });
  }
  async getRSM(id) {
    return await request.post(`${rootRoute}getRSMs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createRSM(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createRSM`, { data });
  }
  async deleteRSM(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteRSM`, { data });
  }
  async editRSM(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateRSM`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importRSM`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getRSMimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportRSM`, {
      filter: filter,
      format: format
    });
  }
}
